<div class="pd-backdrop" (click)="goBack()"></div>
<div class="product-details-container" role="dialog" aria-modal="true"
     [class.pd-no-image]="!product || !hasValidImage(product)">
  <div class="pd-drag-handle" aria-hidden="true"></div>
  <button class="back-button" (click)="goBack()">
    <img src="../../../assets/x.svg" alt="Back">
  </button>

  <div class="pd-scroll">
  <div *ngIf="loading" class="loading">
    Loading product details...
  </div>

  <div *ngIf="product && !loading" class="product-content">
    <!-- Products without a valid image render without an image slide (no placeholder). -->
    <swiper-container class="product-swiper" *ngIf="hasValidImage(product)"
      pagination="true" pagination-dynamic-bullets="true" pagination-clickable="true">
      <!-- Show actual product images -->
      <swiper-slide *ngFor="let image of product.images; let i = index">
        <!-- iOS HalfCircleBottomShape: straight top+sides, gentle half-circle bulge at the bottom. -->
        <svg width="100%" viewBox="0 0 376 308" preserveAspectRatio="xMidYMid meet" fill="none"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <pattern [attr.id]="'pdHero' + i" patternUnits="userSpaceOnUse" width="376" height="308">
              <image [attr.xlink:href]="image.src" width="376" height="308" preserveAspectRatio="xMidYMid meet"
                (load)="onImageLoad(product.id)" (error)="onImageError(product.id)" />
            </pattern>
          </defs>
          <path d="M 0,10 Q 0,0 10,0 L 366,0 Q 376,0 376,10 L 376,230 A 308 308 0 0 1 0,230 Z"
            fill="var(--menu-item-background, #252525)" />
          <path d="M 0,10 Q 0,0 10,0 L 366,0 Q 376,0 376,10 L 376,230 A 308 308 0 0 1 0,230 Z"
            [attr.fill]="'url(#pdHero' + i + ')'" />
        </svg>
      </swiper-slide>
    </swiper-container>
    <div class="product-info-container">
      <div class="product-info">
        <div class="product-info-header">
          <h1>{{getProductName(product, currentLang)}}</h1>
          <div class="price" *ngIf="!product.on_sale">
            {{product.price | price}} <span [innerHTML]="currencySymbol"></span>
            <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.price)">  {{getSecondPrice(product.price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
          </div>
          <div class="price" *ngIf="product.on_sale">
            {{product.sale_price | price}} <span [innerHTML]="currencySymbol"></span>
            <span class="original-price"> {{product.regular_price | price}} </span>
            <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.sale_price)">  {{getSecondPrice(product.sale_price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
            <span class="second-price second-regular-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.regular_price)">  {{getSecondPrice(product.regular_price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
          </div>
        </div>

        <!--
          "In your order" sits ABOVE the description on purpose: it is the context a guest needs
          BEFORE ticking anything, and below the fold it may as well not exist. Rendered only for a
          dish that HAS add-ons — one without them occupies a single line, so there is nothing to
          tell apart (see showOrderContext).
        -->
        <section class="ao-order-context" *ngIf="showOrderContext">
          <h2 class="ao-heading">{{ 'addOns.inYourOrder' | translate }}</h2>

          <div class="ao-line" *ngFor="let line of orderLines; trackBy: trackLine"
               [class.ao-line-loaded]="isLoadedLine(line)">
            <!-- An accent bar rather than a tint alone: the row also loses its stepper when
                 loaded, and two simultaneous changes need one obvious cause. -->
            <span class="ao-line-bar" aria-hidden="true"></span>

            <button type="button" class="ao-line-main"
                    [disabled]="!supplementsSelectable"
                    (click)="loadLine(line)">
              <span class="ao-line-name">{{ combinationName(line) }}</span>
              <span class="ao-line-meta">
                <span class="ao-line-total">
                  {{ lineTotal(line) | price }} <span [innerHTML]="currencySymbol"></span>
                  <span class="ao-second" *ngIf="isSecondCurrencyActive() && getSecondPrice(lineTotal(line))">{{ getSecondPrice(lineTotal(line)) }} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
                </span>
                <span class="ao-chip" *ngIf="isLoadedLine(line)">{{ 'addOns.editing' | translate }}</span>
              </span>
            </button>

            <!-- No stepper on the loaded row on purpose: the bottom bar owns this line's quantity
                 while it is loaded. Two controls for one number — one committing instantly, one
                 pending until "save changes" — is baffling in the hand. -->
            <span class="ao-line-qty" *ngIf="isLoadedLine(line) || !supplementsSelectable">&times;{{ line.quantity }}</span>

            <!-- These target the exact line, so they need no mode switch and never touch the bar. -->
            <div class="ao-stepper" *ngIf="!isLoadedLine(line) && supplementsSelectable">
              <button type="button" (click)="adjustLineQuantity(line, -1)" aria-label="minus">
                <svg class="ao-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <span class="ao-stepper-qty">{{ line.quantity }}</span>
              <button type="button" (click)="adjustLineQuantity(line, 1)" aria-label="plus">
                <svg class="ao-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- The way back out of edit mode. Offered only while a row is loaded — in add mode the
               ticks are already a blank slate and the row would do nothing. -->
          <button type="button" class="ao-new-combination"
                  *ngIf="isEditingLine && supplementsSelectable"
                  (click)="startNewCombination()">
            <svg class="ao-glyph" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="9" cy="9" r="7.25" stroke="currentColor" stroke-width="1.5"/>
              <path d="M9 5.75V12.25M5.75 9H12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>{{ 'addOns.startNewCombination' | translate }}</span>
          </button>
        </section>

        <div class="description" [innerHTML]="getProductDisplayDescription(product, currentLang)"></div>

        <!--
          The picker. Omitted entirely for a product with no add-ons, so those render exactly as
          they did before this feature. Shown but read-only when ordering is off: "Extra cheese
          +50" is menu information, not an ordering action.
        -->
        <section class="ao-picker" *ngIf="hasSupplements">
          <div class="ao-picker-header">
            <h2 class="ao-heading">{{ 'addOns.title' | translate }}</h2>
            <span class="ao-optional">{{ 'addOns.optional' | translate }}</span>
          </div>

          <button type="button" class="ao-row"
                  *ngFor="let supplement of supplements; trackBy: trackSupplement"
                  [class.ao-row-selected]="isSupplementSelected(supplement)"
                  [disabled]="!supplementsSelectable"
                  (click)="toggleSupplement(supplement)">
            <span class="ao-row-name">{{ supplementName(supplement) }}</span>
            <span class="ao-row-price">
              +{{ supplementPrice(supplement) | price }} <span [innerHTML]="currencySymbol"></span>
              <span class="ao-second" *ngIf="isSecondCurrencyActive() && getSecondPrice(supplementPrice(supplement))">{{ getSecondPrice(supplementPrice(supplement)) }} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
            </span>
            <span class="ao-check" *ngIf="supplementsSelectable" aria-hidden="true">
              <svg class="ao-glyph" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1.25" y="1.25" width="15.5" height="15.5" rx="3.75"
                      [attr.fill]="isSupplementSelected(supplement) ? 'currentColor' : 'none'"
                      stroke="currentColor" stroke-width="1.5"/>
                <path *ngIf="isSupplementSelected(supplement)" d="M5 9.25L7.75 12L13 6.5"
                      stroke="var(--menu-accent-text, #FFFFFF)" stroke-width="1.75"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>
  <!-- Pinned to the sheet bottom (outside the scroll region). -->
  <div class="add-to-cart" *ngIf="product && !loading && canEnableOrdering()">
    <div class="add-to-cart-left">
      <div class="quantity-controls">
        <button (click)="updateLocalQuantity(-1)" aria-label="minus">
          <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span [class.animating]="isAnimating" class="quantity-display">
          {{localQuantity}}
        </span>
        <button (click)="updateLocalQuantity(1)" aria-label="plus">
          <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
    <button
      class="add-to-cart-right"
      [class.remove-all]="isRemoveAllAction()"
      (click)="handleCartAction($event, product)">
      <!-- Add-on inclusive, including the converted figure: that one is a pure multiply of
           whatever it is handed, so a base-only number would disagree with the primary. -->
      <span class="price">
        {{ barTotal | price }}
        <span [innerHTML]="currencySymbol"></span>
        <span style="display: block;" *ngIf="isSecondCurrencyActive() && getSecondPrice(barTotal)">  {{getSecondPrice(barTotal)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
      </span>
      <p>{{ getCartActionText() }}</p>
    </button>
  </div>
</div>
